<div class="wrapper">
  <odl-select [formControl]="selectFontFamily">
    {{ 'SETTINGS.FONT_TYPE' | translate }}

    <odl-option value="default">{{ 'DEFAULT' | translate }}</odl-option>
    @for (font of fontFamilyMap; track font.value) {
      <odl-option [value]="font.value">{{ font.label }}</odl-option>
    }
  </odl-select>

  <nr-range-slider
    [formControl]="sliderFontSize"
    [label]="'SETTINGS.FONT_SIZE' | translate"
    [ariaLabel]="'SETTINGS.FONT_SIZE_SLIDER' | translate"
    [min]="0.75"
    [max]="3"
    [step]="0.25"
    iconStart="font_small"
    iconEnd="font_big"
  />

  <nr-range-slider
    [formControl]="sliderLineHeight"
    [label]="'SETTINGS.LINE_SPACING' | translate"
    [ariaLabel]="'SETTINGS.LINE_SPACING_SLIDER' | translate"
    [min]="0.5"
    [max]="3"
    [step]="0.25"
    iconStart="line_spacing_min"
    iconEnd="line_spacing_max"
  />

  @if (fullSettingsEnabled()) {
    <nr-range-slider
      [formControl]="sliderMargin"
      [label]="'SETTINGS.MARGIN' | translate"
      [ariaLabel]="'SETTINGS.MARGIN_SLIDER' | translate"
      [min]="0"
      [max]="1"
      [step]="0.05"
      iconStart="margin_min"
      iconEnd="margin_max"
    />

    <odl-radio-group class="align-group" (odl-input)="changeTextAlign($event)" [value]="align()">
      <span slot="label">{{ 'SETTINGS.ALIGNMENT' | translate }}</span>

      <odl-toggle-chip id="text-align-left" icon="text_align_left" value="left"></odl-toggle-chip>
      <odl-tooltip for="#text-align-left">{{ 'SETTINGS.TEXT_ALIGN_LEFT' | translate }}</odl-tooltip>
      <odl-toggle-chip
        id="text-align-justify"
        icon="text_align_justify"
        value="justify"
      ></odl-toggle-chip>
      <odl-tooltip for="#text-align-justify">
        {{ 'SETTINGS.TEXT_ALIGN_JUSTIFY' | translate }}
      </odl-tooltip>
      <odl-toggle-chip value="start">
        {{ 'SETTINGS.TEXT_ALIGN_DEFAULT' | translate }}
      </odl-toggle-chip>
    </odl-radio-group>
  }
</div>
